import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { AppLoadingShell } from '@/shared/components/app-loading-skeleton'
import useAuth from '../hooks/use-auth'
import useRefreshToken from '../hooks/use-refresh-token'

const isBoneyardBuild = typeof window !== 'undefined' && window.__BONEYARD_BUILD === true

const PersistLogin = () => {
  const [isLoading, setIsLoading] = React.useState(!isBoneyardBuild)
  const refresh = useRefreshToken()
  const { auth, persist } = useAuth()
  const location = useLocation()

  useEffect(() => {
    if (isBoneyardBuild) return
    const verifyRefreshToken = async () => {
      try {
        await refresh()
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoading(false)
      }
    }

    if (!auth?.accessToken) void verifyRefreshToken()
    else setIsLoading(false)
  }, [auth?.accessToken, refresh])

  return (
    <>
      {!persist ? (
        <Outlet />
      ) : isLoading ? (
        <AppLoadingShell pathname={location.pathname} />
      ) : (
        <Outlet />
      )}
    </>
  )
}

export default PersistLogin
